import { FC } from 'react'
import { Box } from '@material-ui/core'
import LoaderIcon from './Icons/LoaderIcon'
import { AvatarGroup } from './AvatarGroup'
import { getStatusColor } from './utils'
import { RiskIcon } from './Icons/RiskIcon'
import TextFormatter from 'components/TextFormatter'
import { CanceledIcon } from './Icons'
import { useTranslation } from 'react-i18next'
import { SkippedStatusIcon } from './Icons/SkippedStatusIcon'

const styles = {
    name: {
        fontSize: '14px',
        color: '#5d6870',
        fontWeight: 'bold',
    },
    position: {
        textTransform: 'uppercase',
        color: '#9b9b9b',
        fontSize: '12px',
        fontWeight: 'bold',
    },
    status: {
        color: '#9230c5',
        fontSize: '14px',
    },
    divider: {
        margin: '0px 10px',
        color: '#d8d8dd',
        width: '16px',
        height: '1px',
    },
    dummyIdentifier: {
        width: '20px',
        position: 'absolute',
        top: '0px',
        left: '10px',
    }
}

const Approver: FC<any> = (props) => {
    const { t } = useTranslation()
    const {
        id,
        size = 'large',
        currentStep,
        showAllApprovers,
        setShowAllApprovers,
        stepId,
        status,
        hasRisk,
        riskViolator,
        showMore
    } = props

    const renderIcon = () => {
        if (hasRisk) {
            return <RiskIcon active={status === 'Open'} />
        } else if (status === 'Canceled') {
            return <CanceledIcon bgColor={'rgb(216, 216, 221)'} />
        } else if (status === 'Skipped') {
            return <SkippedStatusIcon bgColor={'rgb(216, 216, 221)'} />
        } else {
            return <LoaderIcon active={status === 'Open'} />
        }
    }


    return (
        <Box position="relative">
            <Box paddingY="7.5px" display="flex">
                {/*@ts-ignore*/}
                <Box style={{
                    ...styles.dummyIdentifier,
                    height: '51px',
                }} id={id}></Box>
                <Box minWidth={size} marginRight="15px" paddingY="4px">
                    <Box
                        style={{
                            boxShadow: `4px 1px 3px 2px ${getStatusColor(
                                status,
                            )}`,
                            borderRadius: '50%',
                        }}
                    >
                        {renderIcon()}
                    </Box>
                </Box>
                <Box>
                    {status === 'Open' && stepId && (
                        <AvatarGroup
                            open={showAllApprovers}
                            setOpen={setShowAllApprovers}
                        />
                    )}
                    {riskViolator && (
                        <Box display={'flex'} marginTop={'5px'}>
                            <TextFormatter
                                style={{
                                    fontSize: '14px',
                                    color: '#ce2333',
                                    fontWeight: 'bold',
                                }}
                                value={t('MyTasks_RiskViolator') + " : " + riskViolator}
                                maxCharacters={55}
                            />
                        </Box>
                    )}
                    <TextFormatter
                        style={{
                            ...styles.status,
                            color: getStatusColor(status),
                            marginTop: '2px',
                        }}
                        value={currentStep}
                        maxCharacters={70}
                    />
                </Box>
            </Box>
        </Box>
    )
}

export default Approver